import styled from "styled-components";
import { Button } from "../../atoms/button/button";

export const WeeklyScheduleOutlineButton = styled(Button)<{
  isSelected: boolean;
}>`
  border: 2px solid
    ${({ theme, isSelected }) =>
      isSelected ? theme.colors.brand["500"] : theme.colors.periwinkle["500"]};
  color: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.brand["500"] : theme.colors.neutral["900"]};
  background: ${({ isSelected, theme }) =>
    isSelected ? theme.colors.brand["50"] : "transparent"};
  cursor: pointer;
  margin: 10px;
  scroll-snap-align: center;
  &:hover {
    background: none;
  }
`;

export const PageLoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  position: relative;
  margin: 20%;
  text-align: center;
  align-items: center;
`;

export const BreadCrumb = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin: 24px 0 32px 0;
`;

export const KelasLiveBreadCrumb = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-family: ${({ theme }) => theme.fonts.secondary};
  color: ${({ theme }) => theme.colors.neutral["600"]};
`;

export const ArrowBlack = styled.div`
  color: ${({ theme }) => theme.colors.black};
  font-size: ${({ theme }) => theme.fontSizes.xs};
`;

export const WeeklyScheduleBreadcrumb = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-family: ${({ theme }) => theme.fonts.secondary};
  color: ${({ theme }) => theme.colors.black};
`;

export const WeeklyScheduleIconContainer = styled.div`
  display: flex;
  gap: 30px;
  align-items: center;
  margin-top: 40px;
`;

export const JadwalText = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSizes["3xl"]};
`;
export const JadwalSecondaryText = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  color: ${({ theme }) => theme.colors.periwinkle["700"]};
  margin-top: 8px;
`;

export const ScrollDiv = styled.div`
  scroll-snap-align: center;
  display: flex;
`;

export const ScrollContainer = styled.div`
  margin-top: 40px;
`;

export const WeekContainer = styled.div<{ isSelected: boolean }>`
  min-height: 68px;
  min-width: 128px;
  border-radius: 6px;
  border: 2px solid
    ${({ theme, isSelected }) =>
      isSelected ? theme.colors.brand["500"] : theme.colors.periwinkle["500"]};
  margin: 30px 20px 20px 20px;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  gap: 14px;
  cursor: pointer;
  color: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.brand["500"] : theme.colors.black};
  position: relative;
`;

export const Minggu = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
  font-weight: bold;
  margin-top: 10px;
`;

export const Dates = styled.div`
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
`;

export const WeeklyScheduleSessions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  margin-top: 40px;
  margin-bottom: 60px;
`;

export const WeeklyScheduleEmptyContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
`;
export const WeeklyScheduleEmptyTitle = styled.div`
  font-size: ${({ theme }) => theme.fontSizes["3xl"]};
  font-weight: bold;
  font-family: ${({ theme }) => theme.fonts.primary};
  text-align: center;
`;

export const WeeklyScheduleEmptySubTitle = styled.div`
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  font-family: ${({ theme }) => theme.fonts.secondary};
  text-align: center;
`;

export const WeeklyScheduleTimeline = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

export const WeeklyScheduleVerticalTimeline = styled.div`
  display: flex;
  flex-direction: column;
  width: 5%;
  align-items: center;
`;

export const WeeklyScheduleSessionTimline = styled.div`
  display: flex;
  flex-direction: column;
  width: 95%;
  gap: 50px;
`;

export const WeeklyScheduleIconTimelineContainer = styled.div`
  margin: 0;
`;

export const WeeklyScheduleVerticalLine = styled.div`
  width: 1px;
  background-color: ${({ theme }) => theme.colors.periwinkle["400"]};
  height: 280px;
`;

export const TooltipSpan = styled.span`
  width: 120px;
  background-color: ${({ theme }) => theme.colors.brand["500"]};
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  font-weight: bold;
  position: absolute;
  z-index: 1;
  margin-top: -40px;

  &:after {
    content: " ";
    position: absolute;
    top: 100%; /* At the bottom of the tooltip */
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: ${({ theme }) => theme.colors.brand["500"]} transparent
      transparent transparent;
  }
`;
